import {EventEmitter, Injectable}   from "@angular/core";
import { UtilitesService }          from "../../base-module/base-service/utilites.service";
import { AuthService }              from "../../base-module/base-service/auth.service";
import { Observable }               from "rxjs";
import {HttpClient}                 from "@angular/common/http";

@Injectable()
export class OrigemService {

    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Origem do Cliente por id
     * @param id ID da Origem do Cliente
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "origem-cliente/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Origem do Cliente
     * @param id ID da Origem do Cliente
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "origem-cliente"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Origem do Cliente Para Campo Do Cadastro
     */
    getLista(): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "origem-cliente/lista", { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Origem do Cliente
     * @param id ID da Origem do Cliente
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "origem-cliente/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Origem do Cliente
     * @param params Json Origem do Cliente
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "origem-cliente", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Origem do Cliente
     * @param params Json Origem do Cliente
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "origem-cliente/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}
